import { Dashboard } from 'schemas/DashboardSchema'
import { getCountryFilterKey } from 'utils/getCountryFilterKeyUtil'
import { toFilter, deriveCountType } from '../../../../../utils/widgetUtil'
import { createInsightCount } from '../../../../../utils/runSearchUtil'
import { getMeasureByCountTypeAndAnalysisType } from '../../../../../utils/measureUtil'
import { RegionOptions, CountType, Category, ResolutionOptions } from '../../../../../enums'
import { GeoRegionsWidget } from '../../types'

const DEFAULT_SIZE_NEEDED = 1000

export const createGeoInsightCount = (
  widgetSetting: GeoRegionsWidget,
  dashboardData: Dashboard,
  pageConfigUser: any
) => {
  const { id: dashboardId, name: dashboardName } = dashboardData

  const topicIds = [widgetSetting.selectedTopic.topicId!]

  const filter = toFilter(widgetSetting, pageConfigUser.timeZone)

  filter.countries = filter.countries || []
  if (widgetSetting.region !== RegionOptions.WORLD) {
    filter.countries.push([getCountryFilterKey(widgetSetting.region!)])
  }

  const measure = getMeasureByCountTypeAndAnalysisType(
    widgetSetting.countType!,
    widgetSetting.analysisType!
  )

  const categories = [Category.GEOLOCATION]

  const insightCountOptions = {
    sizeNeeded: DEFAULT_SIZE_NEEDED,
    isAuthorBased: deriveCountType(widgetSetting) === CountType.AUTHORS,
    isDMA: widgetSetting.resolution === ResolutionOptions.MARKET_AREAS
  }

  return createInsightCount(
    dashboardId!,
    dashboardName!,
    widgetSetting.precision!,
    topicIds,
    filter,
    measure,
    categories,
    insightCountOptions
  )
}

export default createGeoInsightCount
